import React from 'react';
import { PageHero, Section } from '../components/UI';
import styles from './Terms.module.css';

const SECTIONS = [
  {
    title: 'Course Registration and Payment',
    body: [
      'When you register for an IT training program offered by Metawave Solutions, you agree to the applicable course details, schedule, fees, and payment terms communicated at the time of registration.',
      'Course fees must be paid according to the payment instructions provided by Metawave Solutions.',
    ],
  },
  {
    title: 'Cancellation Before Training Starts',
    body: [
      'If a student wishes to cancel their registration before the scheduled training program begins, the student must contact Metawave Solutions in writing.',
      'Any refund eligibility will depend on the cancellation period and the specific terms communicated for the particular training program. Applicable payment gateway or transaction charges may be deducted from an approved refund where permitted.',
    ],
  },
  {
    title: 'Cancellation After Training Begins',
    body: [
      'Once a training program has started, refunds may not be available because training resources, instructor time, course materials, and other arrangements may already have been committed.',
      'Any request for a refund after commencement of training will be reviewed on a case-by-case basis and will be subject to the applicable course terms.',
    ],
  },
  {
    title: 'Course Materials',
    body: [
      'Where course materials, recordings, software access, learning resources, or other digital content have already been provided to a student, the applicable payment may be non-refundable, subject to the specific terms communicated for the course.',
      "Students are not permitted to share, distribute, reproduce, sell, or commercially use Metawave Solutions' training materials without prior written permission.",
    ],
  },
  {
    title: 'Training Schedule Changes',
    body: [
      'Metawave Solutions may occasionally need to change the training schedule, instructor, timing, or delivery method due to unforeseen circumstances. Where possible, students will be informed in advance and an alternative arrangement may be offered.',
    ],
  },
  {
    title: 'Refund Processing',
    body: [
      "Where a refund is approved, it will generally be processed through the original payment method, where possible. The time required for the refund to reflect in the student's account may depend on the payment gateway or financial institution.",
    ],
  },
  {
    title: 'Non-Refundable Situations',
    body: [
      'Unless otherwise specifically stated for a particular course, fees may be non-refundable where a student has attended the training, accessed course materials, received digital content, or failed to attend scheduled sessions without providing an eligible cancellation request.',
    ],
  },
];

export default function Refund() {
  return (
    <>
      <PageHero
        tag="Legal"
        title="Refund Policy"
        subtitle="Our process for course registration, cancellation, and refunds."
      />

      <Section variant="paper">
        <div className={styles.container}>
          <p className={styles.intro}>
            Metawave Solutions provides IT training programs designed to
            help students and professionals develop technical and
            industry-relevant skills. We aim to provide a clear and
            transparent process for course registration, cancellation, and
            refunds.
          </p>

          {SECTIONS.map((s, i) => (
            <div key={i} className={styles.block}>
              <h3 className={styles.blockTitle}>{s.title}</h3>
              {s.body.map((p, j) => (
                <p key={j} className={styles.bodyText}>
                  {p}
                </p>
              ))}
            </div>
          ))}

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>Contact Us</h3>
            <p className={styles.bodyText}>
              For questions regarding course cancellations or refunds,
              please contact Metawave Solutions using the contact details
              provided on our website.
            </p>
            <p className={styles.bodyText}>
              Website:{' '}
              <a href="https://www.metawavesolutions.com">
                www.metawavesolutions.com
              </a>
              <br />
              Email: <a href="mailto:accounts@metawavesolutions.com">accounts@metawavesolutions.com</a>
            </p>
          </div>
        </div>
      </Section>
    </>
  );
}
